import type { Translation } from '../Store'

function getTranslation(translations: Translation[] | undefined, locale: string) {
  if (!translations || translations.length === 0)
    return {
      description: '-',
      locale: '-',
      name: '-',
      short_name: '-',
      value: '-',
      additional_name: '-'
    }

  return (
    translations.find(t => t.locale.toLowerCase() === locale.toLowerCase()) ?? {
      description: '-',
      locale: '-',
      name: '-',
      short_name: '-',
      additional_name: '-',
      value: '-'
    }
  )
}

export default getTranslation
